<template>
  <div class="modal-mask">
    <div class="card">
      <label class="title">Add new FAQ</label>
      <label class="description"
        >Please enter a question and answer to add to FAQ list</label
      >

      <form class="form">
        <div class="form-group">
          <label class="ionput-label">Question</label>
          <input
            class="form-control"
            placeholder="Enter the question here"
            v-model="question"
          />
        </div>

        <div class="form-group">
          <label class="ionput-label">Answer</label>
          <input
            class="form-control"
            placeholder="Enter the answer for the question"
            v-model="answer"
          />
        </div>
      </form>

      <div class="actions">
        <button
          class="btn btn-outline-primary w-100 font-weight-bold"
          @click="cancel"
        >
          Cancel
        </button>
        <button class="btn btn-primary w-100 font-weight-bold" @click="save">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP, URLS } from "../network/http";
let NotificationsController = require("./NotificationsController");

export default {
  name: "CreateFAQComponent",
  props: ["schemtics"],
  data() {
    return {
      question: "",
      answer: "",
    };
  },
  methods: {
    save() {
      if (!this.question || this.question == "") {
        this.$toast.error("Please enter a question for the FAQ");
        return;
      }
      if (!this.answer || !this.answer[0]) {
        this.$toast.error("Please enter an answer for the FAQ");
        return;
      }
      NotificationsController.showActivityIndicator();
      let data = {
        question: this.question,
        answer: this.answer,
      };

      HTTP.post(URLS.FAQ.CREATE, data)
        .then((faq) => {
          this.$toast.success(faq.data.message);
          NotificationsController.hideActivityIndicator();
          this.$emit("success", faq.data);
        })
        .catch((err) => {
          var msg = "";
          try {
            msg = err.response.data.message;
          } catch (error) {
            msg = err.message;
          }
          this.$toast.error(msg);
          this.$emit("fail", err.response);
          NotificationsController.hideActivityIndicator();
        });
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
.preview-container {
  display: flex;
  flex-direction: column;

  .preview {
    width: 16rem !important;
    height: 9rem !important;
  }
}
.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;

  .card {
    width: 50%;
    max-height: 80%;
    background-color: white;
    border-radius: 4px;
    padding: 20px;

    .title {
      width: 100%;
      line-height: 50px;
      font-size: 20px;
      color: black;
    }

    .description {
      width: 100%;
      font-size: 16px;
      text-align: left;
      color: gray;
      margin-top: -20px;
      margin-bottom: 1rem;
    }

    .form {
      max-height: calc(100% - 200px);
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: scroll;
    }

    .actions {
      height: 50px;
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-top: 20px;
    }
  }
}
</style>
